export const FCAVerificationType = {
  FS: 1,
  Gov: 2,
  NonFS: 3,
};

export const FCAAccountStatus = {
  Pending: 1,
  Verified: 2,
  VerifiedLimited: 3,
  Failed: 4,
};

export const FCAAccountDomainStatus = {
  Create: 1,
  NQPPending: 2,
  Verified: 3,
  Failed: 4,
  Deleted: 5,
};

export const FCAVerificationTypeString = {
  [FCAVerificationType.FS]: 'UK FCA authorized financial services advertiser',
  [FCAVerificationType.Gov]: 'Government entity',
  [FCAVerificationType.NonFS]: 'Non-financial services advertiser',
};

export const FCAVerificationAccountStatusString = {
  [FCAAccountStatus.Pending]: 'Pending',
  [FCAAccountStatus.Verified]: 'Verified',
  [FCAAccountStatus.VerifiedLimited]: 'Verified limited',
  [FCAAccountStatus.Failed]: 'Failed',
};
